import { createClient } from '@/shared/api';
import type {
  SendStudyReferenceCodeMutation,
  SendStudyReferenceCodeMutationVariables,
} from '@/shared/api';
import SEND_STUDY_REFERENCE_CODE from '../mutations/sendStudyReferenceCode';

/**
 * Sends the study reference code to the patient. Runs the SEND_STUDY_REFERENCE_CODE mutation and returns the sendStudyReferenceCode payload without checking a success flag.
 *
 * @param input - Mutation input payload.
 * @returns The sendStudyReferenceCode payload.
 */
const handleSendStudyReferenceCode = async (
  input: SendStudyReferenceCodeMutationVariables['input'],
): Promise<SendStudyReferenceCodeMutation['sendStudyReferenceCode'] | undefined> => {
  const client = createClient();
  const result = await client.mutate<
    SendStudyReferenceCodeMutation,
    SendStudyReferenceCodeMutationVariables
  >({
    mutation: SEND_STUDY_REFERENCE_CODE,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { sendStudyReferenceCode } = data ?? {};
  return sendStudyReferenceCode;
};

export default handleSendStudyReferenceCode;
